import React from 'react';
import './style.css'
import LocationListItem from "./LocationListItem";
import {LocationItemLinkRoot} from "../styles";


const LocationListItemLink = (props) => {
  const { location, to, listHover, setListHover, showVisibilityChip, isFavorite } = props;

  return (
    <div className='ss-listing-location-list-item'>
      <LocationItemLinkRoot to={`${to}`} target={'_blank'}>
        <LocationListItem
          location={location}
          listHover={listHover}
          setListHover={setListHover}
          showVisibilityChip={showVisibilityChip}
          isFavorite={isFavorite}
        />
      </LocationItemLinkRoot>
    </div>
  );
};

export default LocationListItemLink;
